<script>
import Modal from '../../../components/Modal.vue'

export default {
    components: {
        Modal
    },
    
    props: {
        enableSendToSage: {
            type: Boolean,
            required: false
        }
    },

    methods: {
        toggleModal() {
            this.$refs.modal.toggle()
        },
        passSendToSage() {
            this.$emit('passSendToSage')
        },
        passOnly() {
            this.$emit('passOnly')
        },
    }
}
</script>

<template>
    <modal ref="modal" heading="Pass Applicant">
        
        <div class="mb-4">
            <h5>You are moving this candidate to Start, would you like to Send this Candidate to Sage?</h5>
        </div>

        <div class="grid-x grid-padding-x align-right">
            <div class="cell shrink">
                <button v-if="enableSendToSage" class="button" type="button" @click="passSendToSage">Send to Sage</button>
                <button v-else disabled title="The job profile linked to this requisition is missing the External Req # and the Sage Req ID, please correct in order to Sync to Sage" class="button disabled">Send to Sage</button>
            </div>

            <div class="cell shrink">
                <button class="button warning" type="button" @click="passOnly">No do not send to Sage, just to Start</button>
            </div>
        </div>
    </modal>
</template>